export { ClaimsPage as default } from './claims-page'
